import { render, staticRenderFns } from "./ViewMethodScreening.vue?vue&type=template&id=693d4ffb&scoped=true"
import script from "./ViewMethodScreening.vue?vue&type=script&lang=js"
export * from "./ViewMethodScreening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693d4ffb",
  null
  
)

export default component.exports